import { LOADER_RANDOM_IMAGE_COUNT } from "./loader.constants";

export function seedRandomImage(): number {
    return Math.floor(Math.random() * LOADER_RANDOM_IMAGE_COUNT);
}
